import { useEffect, useRef } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import { useIntercom } from '@zenbusiness/application-commons-intercom';

export default function UserIdentityManager() {
  const { user, userUuid } = useIdentity() ?? {};
  const previousUserUuidRef = useRef();
  const { update: updateIntercom } = useIntercom();
  const trackLogoutCompleted = useClickstreamCallback('logoutCompleted');
  const trackUserUnidentified = useClickstreamCallback('userUnidentified');

  useEffect(() => {
    const previousUserUuid = previousUserUuidRef.current;

    // update intercom with user identity
    if (user) {
      updateIntercom({
        email: user.accountEmail,
        name: user.name,
        creationDate: user.createdAt,
        user_id: userUuid
      });
    }

    // User is logging out
    if (previousUserUuid && !userUuid) {
      trackLogoutCompleted();
      trackUserUnidentified();
    }

    previousUserUuidRef.current = userUuid;
  }, [trackLogoutCompleted, trackUserUnidentified, updateIntercom, user, userUuid]);

  return false;
}
